<script lang="ts" setup>
import {
  callOnce,
  computed,
  defineOgImageComponent,
  useHead,
  useMaps,
} from "#imports";
import MPMapCard from "~/components/layouts/MPMapCard.vue";
import MPSectionHeader from "~/components/layouts/MPSectionHeader.vue";

const mapStore = useMaps();

const data = computed(() => mapStore.recentMaps);

const loadData = async () => {
  await mapStore.fetchRecentMaps({ limit: 20 });
};
await callOnce(loadData);

useHead(() => ({
  title: "Explore Mappr",
  meta: [
    {
      name: "description",
      content:
        "Maps, Spots and unique experiences; Explore curated lists from local experts and global creators",
    },
  ],
}));

defineOgImageComponent("Default", {
  title: "Explore Mappr",
  description:
    "Maps, Spots and unique experiences; Explore curated lists from local experts and global creators",
});
</script>

<template>
  <main class="maps-page">
    <header class="page-header">
      <MPSectionHeader
        subtitle="Creator Curated Maps"
        title="Find Your Next Adventure"
        summary="Search for the destination you want, and view all our unique maps and spots"
      />
    </header>
    <main class="mapgrid">
      <div v-for="map in data" :key="map.id">
        <MPMapCard :mapId="map.id" />
      </div>
    </main>
  </main>
</template>

<style lang="postcss" scoped>
@import "@/assets/css/breakpoints.pcss";
@import "@/assets/css/layouts.pcss";
.maps-page {
  margin: 0 auto;
  @mixin layout-wrapper-wide;
  margin-top: 1rem;
  display: grid;
  align-items: center;
}

.page-header {
  margin: 1.5rem 0;
  @mixin screen md {
    margin: 3rem 0 1.5rem;
    margin-top: 4rem;
  }
}

.mapgrid {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1rem;
  padding-inline: 1rem;

  @mixin screen sm {
    grid-template-columns: repeat(2, 1fr);
  }

  @mixin screen md {
    grid-template-columns: repeat(3, 1fr);
  }

  @mixin screen lg {
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>
